import react, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const DataGridHook = ({ props }) => {
    const [rows, setRows] = useState([]);
    const [loader, setLoader] = useState(true);
    const [showPopover, setShowPopover] = useState(null);
    const [positionX, setPositionX] = useState(0);
    const [positionY, setPositionY] = useState(0);
    const [ticketId, setTicketId] = useState(0);
    const [dataUsersList, setDataUserList] = useState(null);
    const navigate = useNavigate();

    const {
        getTickets,
        generalTickets,
        cleanGeneralTicketsAction,
        getUsers,
        userList,
        changeUser,
        changeUser_,
    } = props || {};

    const { response } = userList || {};

    const open = Boolean(showPopover);

    const id = open ? "simple-popover" : undefined;

    useEffect(() => {
        getTickets();
        getUsers();
        setLoader(true);
        return () => {
            cleanGeneralTicketsAction();
        };
    }, []);

    useEffect(() => {
        generateRows();
    }, [generalTickets]);

    useEffect(() => {
        if (userList) {
            setDataUserList(response.users);
        }
    }, [userList]);

    useEffect(() => {
        if (changeUser_.loading) {
            getTickets();
            handleClose();
        }
    }, [changeUser_]);

    const generateRows = () => {
        const { loaded, method, payload, state, status } = generalTickets || {};

        if (loaded) {
            const { pagination, tickets } = payload || {};
            setLoader(false);

            setRows(tickets);
        }
    };

    const handleNavigate = (params) => {
        if (
            typeof params?.target?.id != "undefined" &&
            typeof params?.target?.name != "undefined"
        ) {
            navigate("/tickets/" + params.target.id, {
                state: { directNumber: params.target.name },
            });
        }
    };

    const handleChangeUser = (params) => {
        changeUser({ ticketId: ticketId, user_id: params.id });
    };

    const handleClick = (params) => {
        setShowPopover(params.events.currentTarget);
        setPositionX(params.events.clientX + 30);
        setPositionY(params.events.clientY + 10);
        setTicketId(params.ticketId);
    };

    const handleClose = () => {
        setShowPopover(null);
    };

    return {
        handleClose,
        handleClick,
        handleNavigate,
        handleChangeUser,
        loader,
        dataUsersList,
        rows,
        showPopover,
        positionX,
        positionY,
        open,
    };
};
